import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { paths } from '@/config/paths';
import { useProfilesData } from '@/features/user/api';

import { DASHBOARD_COMPONENTS, getTemplate } from './index';

export const useBhanzuBuddyFeatures = () => {
  const { selectedCourse } = useProfilesData();
  const currentPathname = useLocation().pathname;

  const template = useMemo(
    () => getTemplate(selectedCourse?.product_name),
    [selectedCourse?.product_name]
  );

  const { dashboardComponents } = template;

  return useMemo(
    () => ({
      showBhanzuBuddy:
        (dashboardComponents.includes(
          DASHBOARD_COMPONENTS.BHANZU_BUDDY_WITH_QUICK_CHALLENGE
        ) ||
          dashboardComponents.includes(
            DASHBOARD_COMPONENTS.BHANZU_BUDDY_WITHOUT_QUICK_CHALLENGE
          )) &&
        currentPathname !== paths.app.onboarding.path,
      enableQuickChallenge: dashboardComponents.includes(
        DASHBOARD_COMPONENTS.BHANZU_BUDDY_WITH_QUICK_CHALLENGE
      ),
    }),
    [currentPathname, dashboardComponents]
  );
};
